module.exports = __webpack_public_path__ + "static/media/03.b7ad5341.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/verdindung/03.png
// module id = 119
// module chunks = 0